export default "__VITE_ASSET__sZzbZ8lj__"